import { useSlideshowBullets } from '@fukku/slideshow/hooks/useSlideshowBullets/useSlideshowBullets'
import { useSlideshowContext } from '@fukku/slideshow/hooks/useSlideshowContext/useSlideshowContext'
import { type JSX, useCallback } from 'react'
import { cx } from 'utils/cx'
import styles from './SlideshowDots.module.css'

type SlideshowDotsProps = {
	readonly children: JSX.Element[]
}

export const SlideshowDots = ({ children }: SlideshowDotsProps) => {
	const { bulletIndex, firstBulletIndex, lastBulletIndex } =
		useSlideshowBullets()
	const { blockTouchEvents, nItems } = useSlideshowContext()

	const bulletStyle = useCallback(
		(index: number) => {
			if (index < firstBulletIndex || index > lastBulletIndex) {
				return styles.hidden
			}

			const isFirstBulletMore = index === firstBulletIndex && index > 0
			const isLastBulletMore = index === lastBulletIndex && index < nItems - 1

			if (isFirstBulletMore || isLastBulletMore) {
				return styles.more
			}

			if (index === bulletIndex) {
				return styles.active
			}

			return undefined
		},
		[firstBulletIndex, lastBulletIndex, nItems, bulletIndex]
	)

	return (
		<div
			className={cx(styles.bullets, blockTouchEvents && styles.fadeOutBullets)}
		>
			{children.map((child, index) => (
				<span
					className={cx(styles.bullet, bulletStyle(index))}
					key={child.key}
					data-testid='slideshow.bullet'
				/>
			))}
		</div>
	)
}
